import React, { Component } from "react";
import { Link } from "react-router-dom";
class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { mediaPartners } = this.props;

    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={0}
          data-smobile={0}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          <div className="widget widget_list">
            <div className="inner">
              <ul className="list-wrap">
                <li className="list-item">
                  <Link
                    to="/about/cityx-team"
                    onClick={() => {
                      window.location.href = "/about/cityx-team";
                    }}
                  >
                    <span className="text">CityX Team</span>
                  </Link>
                </li>
                <li className="list-item">
                  <a to="/about/carees">
                    <span
                      className="text"
                      onClick={() => {
                        window.location.href = "/about/carees";
                      }}
                    >
                      Karijere
                    </span>
                  </a>
                </li>
                <li className="list-item">
                  <a href="/news-list-media">
                    <span className="text">CityX u medijima</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
        {/* /.widget_gallery */}
        {mediaPartners.length ? (
          <div className="widget widget_instagram margin-top-51">
            <h2 className="widget-title margin-bottom-30">
              <span>O NAMA PIŠU</span>
            </h2>
            <div className="instagram-wrap data-effect clearfix col3 g10">
              {mediaPartners.map((data, idx) => (
                <div className="instagram_badge_image has-effect-icon">
                  <a
                    href={data.mediaURL}
                    className="data-effect-item"
                    style={{ border: "1px solid rgba(100,100,100,.2)" }}
                  >
                    <span className="item">
                      <img src={data.mediaSquareTh} alt={data.mediaName} />
                    </span>
                    <div className="overlay-effect bg-color-2" />
                    <div className="elm-link">
                      <span className="icon-3" />
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default SideBar;
